module.exports = __webpack_public_path__ + "img/dap5.28614db2.jpg";